import { render, staticRenderFns } from "./addvideo.vue?vue&type=template&id=3ced858b&scoped=true"
import script from "./addvideo.vue?vue&type=script&lang=js"
export * from "./addvideo.vue?vue&type=script&lang=js"
import style0 from "./addvideo.vue?vue&type=style&index=0&id=3ced858b&prod&scoped=true&lang=css"
import style1 from "./addvideo.vue?vue&type=style&index=1&id=3ced858b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ced858b",
  null
  
)

export default component.exports